import { render, staticRenderFns } from "./favorites.vue?vue&type=template&id=0758ff20&scoped=true"
import script from "./favorites.vue?vue&type=script&lang=js"
export * from "./favorites.vue?vue&type=script&lang=js"
import style0 from "./favorites.vue?vue&type=style&index=0&id=0758ff20&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0758ff20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0758ff20')) {
      api.createRecord('0758ff20', component.options)
    } else {
      api.reload('0758ff20', component.options)
    }
    module.hot.accept("./favorites.vue?vue&type=template&id=0758ff20&scoped=true", function () {
      api.rerender('0758ff20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/favorites.vue"
export default component.exports